import { QUERY_KEYS as BASE_QUERY_KEYS } from "@repo/baseCloud";

export const QUERY_KEYS = {
	...BASE_QUERY_KEYS,
	Locations: {
		...BASE_QUERY_KEYS.Locations,
		Brands: "brands",
		Channels: "channels",
		Marketers: "marketers",
		States: "states",
		PartnerTypes: "partnerTypes",
		Partners: "partners",
		Statuses: "locationStatuses",
		Vendors: "vendors",
		Offices: "offices",
		LocationStates: "locationStates",
		BranchChannels: "branchChannels",
		BranchMarketers: "branchMarketers",
		BranchStates: "branchStates",
		Branches: "branches",
		ImportTypes: "importTypes",
		ImportMonths: "importMonths",
		ImportYears: "importYears",
		CompanyDivisions: "companyDivisions",
		CompanyRegions: "companyRegions",
		CompanyMarkets: "companyMarkets",
	},
	Leads: {
		Leads: "leads",
		RetailLocations: "retailLocations",
	},
	Representatives: {
		Reps: "reps",
		RepTypes: "repTypes",
		Settings: "settings",
	},
	Login: {
		AuthSettings: "AuthSettings",
		MfaTypes: "MfaTypes",
	},
	Complaints: {
		ComplaintTypes: "complaintTypes",
		ComplaintSources: "complaintSources",
		Users: "users",
		ReportingTags: "reportingTags",
		AffiliatePartners: "affiliatePartners",
		ComplaintOrIncident: "complaintOrIncident",
		Complaints: "complaints",
	},
	EnrollmentValidations: {
		Grid: "EnrollmentValidations",
		Users: "EnrollmentValidationUsers",
		Types: "EnrollmentValidationTypes",
	},
	DrugTests: {
		Grid: "DrugTestsGrid",
	},
	Disciplines: {
		Grid: "DisciplinesGrid",
		Trainings: "DisciplineTrainings",
	},
	AppSettings: {
		Definitions: "AppSettingDefinitions",
		Settings: "AppSettings",
	},
	BackgroundChecks: {
		Grid: "BackgroundChecksGrid",
		Configurations: "BackgroundChecksConfigurations",
	},
	FieldAudits: {
		Grid: "FieldAuditsGrid",
		Locations: "FieldAuditsLocations",
	},
	Maps: {
		MapSettings: "MapSettings",
		LiveView: "liveView",
		GeographicView: "geographicView",
		Positions: "positions",
		Sales: "sales",
		Leads: "leads",
		RetailLocations: "retailLocations",
		AllStates: "AllStates",
		MapLayer: "mapLayer",
		MapConfigurations: "mapConfigurations",
	},
	MyView: {
		Boards: "myViewBoards",
	},
	Components: {
		...BASE_QUERY_KEYS.Components,
		Geocode: "geocode",
	},
} as const;

// Backward-compatible named exports for existing imports (api/queries.ts consumers)
export const BRANCHES = QUERY_KEYS.Locations.Branches;
export const CHANNELS = QUERY_KEYS.Locations.Channels;
export const BRANDS = QUERY_KEYS.Locations.Brands;
export const MARKETERS = QUERY_KEYS.Locations.Marketers;
export const STATES = QUERY_KEYS.Locations.States;
export const REPTYPES = QUERY_KEYS.Representatives.RepTypes;
export const REPS_SETTINGS = QUERY_KEYS.Representatives.Settings;

export const GET_USER_INFO = QUERY_KEYS.Users.GetUserInfo;

export const COMPANIES = QUERY_KEYS.Companies.Companies;
export const DIVISIONS = QUERY_KEYS.Companies.Divisions;
export const REGIONS = QUERY_KEYS.Companies.Regions;
export const MARKETS = QUERY_KEYS.Companies.Markets;
